import { useMutation } from "@tanstack/react-query";

import { cancelEvent } from "../../services/events";

export const useCancelEvent = (id: string | number, onSuccess?: () => void, onError?: () => void) => {
  return useMutation({
    mutationFn: async (body: { cancelEventReason: string | undefined; cancelEventComment: string | null }) => {
      return await cancelEvent(id, body);
    },
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
    onError: () => {
      if (onError) onError();
    },
  });
};
